import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Card from 'components/card'
import Image from 'components/image'
import { CelebrateIcon } from 'components/icons'
import css from './feed-items.scss'
import { getCreatedAt } from 'registry/reducers'
import { minutesSince } from 'lib/date'
import { SectionHeading } from '../../../../components/headings'

class WelcomeCard extends PureComponent {
  render() {
    const { registryCreatedAt, teaser, title } = this.props

    if (minutesSince(registryCreatedAt) >= 20) {
      return null
    }

    return (
      <Card className={classNames(css.iconLayout, css.welcome, 'mbxl')}>
        <div className={classNames(css.info, 'flex col center')}>
          <div className={classNames(css.iconBg, 'flex center mtl mbs')}>
            <CelebrateIcon />
          </div>
          <SectionHeading className="h3 mtn text-bold text-brand-info">
            {title}
          </SectionHeading>
          <p className="text-body">{teaser}</p>
        </div>
        <div className={css.footer}>
          <Image
            role="presentation"
            src="//images.babylist.com/image/upload/f_auto,q_auto,c_scale,w_120/v1547580354/Babylist_logo_horizontal_oawglq.svg"
          />
          <div className="h6 man">
            Sending virtual hugs and real advice since 2011
          </div>
        </div>
      </Card>
    )
  }
}

WelcomeCard.propTypes = {
  title: PropTypes.string,
  teaser: PropTypes.string,
}

const mapStateToProps = (state) => ({
  registryCreatedAt: getCreatedAt(state),
})

export default connect(mapStateToProps, {})(WelcomeCard)
